import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { verifyPin } from "@/lib/api";

interface PinModalProps {
  onSuccess: (pin: string) => void;
}

export function PinModal({ onSuccess }: PinModalProps) {
  const [pin, setPin] = useState("");
  const [error, setError] = useState("");
  const [verifying, setVerifying] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!pin) {
      setError("Please enter a PIN");
      return;
    }
    setVerifying(true);
    setError("");
    try {
      const valid = await verifyPin(pin);
      if (valid) {
        onSuccess(pin);
      } else {
        setError("Incorrect PIN");
      }
    } catch {
      setError("Failed to verify PIN");
    } finally {
      setVerifying(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div
        className="p-8 rounded-lg max-w-md w-full mx-4"
        style={{
          backgroundColor: "#FFFFFF",
          boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
        }}
      >
        <h2
          className="text-2xl mb-4"
          style={{
            fontFamily: "Georgia, serif",
            color: "#3A3A3A",
          }}
        >
          Admin Access
        </h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label
              htmlFor="pin"
              className="block mb-2"
              style={{
                fontFamily: "Helvetica Neue, sans-serif",
                color: "#3A3A3A",
              }}
            >
              Enter PIN
            </label>
            <Input
              id="pin"
              type="password"
              value={pin}
              onChange={(e) => {
                setPin(e.target.value);
                setError("");
              }}
              placeholder="****"
              autoFocus
            />
            {error && (
              <p className="mt-2 text-sm" style={{ color: "#B8795F" }}>
                {error}
              </p>
            )}
          </div>
          <Button
            type="submit"
            className="w-full"
            disabled={verifying}
            style={{
              backgroundColor: "#5B8A8F",
              color: "#FFFFFF",
            }}
          >
            {verifying ? "Verifying..." : "Enter"}
          </Button>
        </form>
      </div>
    </div>
  );
}
